"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ModalRow = exports.ModalList = exports.ModalButtonWrapper = exports.ModalSubhead = exports.ModalHeadline = exports.ModalCopy = exports.ModalContent = exports.ModalWrapper = void 0;
require("core-js/modules/es6.object.assign");
const react_1 = __importDefault(require("react"));
const react_dom_1 = __importDefault(require("react-dom"));
const styled_components_1 = __importDefault(require("styled-components"));
const _theme_1 = require("@theme");
const _utils_1 = require("@utils"); // Component
var Modal = function Modal(_ref) {
    var visible = _ref.visible, setVisible = _ref.setVisible, children = _ref.children;
    react_1.default.useEffect(function () {
        if (visible) {
            document.getElementsByTagName('body')[0].classList.add('modal-no-scroll');
        }
        else {
            document.getElementsByTagName('body')[0].classList.remove('modal-no-scroll');
        }
        return function () {
            return document.getElementsByTagName('body')[0].classList.remove('mobile-no-scroll');
        };
    }, [visible]);
    return /*#__PURE__*/ react_dom_1.default.createPortal(/*#__PURE__*/ react_1.default.createElement(Wrapper, {
        visible: visible
    }, /*#__PURE__*/ react_1.default.createElement(Overflow, null, /*#__PURE__*/ react_1.default.createElement(Content, {
        visible: visible
    }, children)), /*#__PURE__*/ react_1.default.createElement(CloseButton, Object.assign({
        visible: visible
    }, {
        onClick: function onClick() {
            return setVisible(false);
        }
    }), /*#__PURE__*/ react_1.default.createElement(Cross, {
        visible: visible
    })), visible && /*#__PURE__*/ react_1.default.createElement(CloseShroud, {
        onClick: function onClick() {
            return setVisible(false);
        }
    })), document.getElementById('modal-root'));
}; // Styling
var Wrapper = styled_components_1.default.div.withConfig({
    displayName: "Modal__Wrapper",
    componentId: "sc-64uwmw-0"
})(["z-index:11001;position:fixed;top:0;left:0;background-color:", ";width:100%;height:100vh;max-height:100vh;opacity:", ";visibility:", ";transition:opacity 0.35s ease-in-out,visibility 0.35s ease-in-out;will-change:opacity;transition-delay:", "s;overflow:auto;-webkit-overflow-scrolling:touch;&::-webkit-scrollbar{width:0px;height:0px;}"], _utils_1.rgba(_theme_1.palette.black, 0.64), function (props) {
    return props.visible ? 1 : 0;
}, function (props) {
    return props.visible ? 'visible' : 'hidden';
}, function (props) {
    return props.visible ? 0 : 0.6;
});
var Overflow = styled_components_1.default.div.withConfig({
    displayName: "Modal__Overflow",
    componentId: "sc-64uwmw-1"
})(["position:absolute;z-index:2;width:100%;height:100%;max-height:100%;pointer-events:none;"]);
var Content = styled_components_1.default.div.withConfig({
    displayName: "Modal__Content",
    componentId: "sc-64uwmw-2"
})(["display:flex;flex-wrap:wrap;justify-content:center;align-items:center;width:100%;height:100%;min-height:fit-content;padding:80px 24px;pointer-events:none;opacity:", ";transform:translate3d(", ") scale3d(", ");transition-delay:0.3s;transition:opacity 0.35s ease-in-out,transform 0.35s ease-in-out;will-change:opacity,transform;", "{padding-top:100px;padding-bottom:100px;}", "{padding-top:120px;padding-bottom:120px;}& > *{pointer-events:", ";}"], function (props) {
    return props.visible ? 1 : 0;
}, function (props) {
    return props.visible ? '0, 0, 0' : '0, 5px, 0';
}, function (props) {
    return props.visible ? '1, 1, 1' : '0.98, 0.98, 1';
}, _utils_1.mediaQuery('laptop'), _utils_1.mediaQuery('desktop'), function (props) {
    return props.visible ? 'all' : 'none';
}); // Close Button
var CloseButton = styled_components_1.default.div.withConfig({
    displayName: "Modal__CloseButton",
    componentId: "sc-64uwmw-3"
})(["position:absolute;z-index:2;top:12px;right:12px;display:flex;justify-content:center;align-items:center;background-color:", ";width:40px;height:40px;border-radius:50%;box-shadow:0px 8px 16px rgba(0,0,0,0.08);overflow:hidden;cursor:pointer;opacity:", ";transform:scale3d(", ");transition:opacity 0.35s ", "s ease-in-out,transform 0.6s ", "s cubic-bezier(0.68,-0.55,0.265,1.55);will-change:opacity,transform;", "{position:fixed;top:20px;right:32px;}", "{top:12px;right:24px;width:56px;height:56px;}", "{top:16px;right:20px;width:64px;height:64px;}"], _utils_1.rgba(_theme_1.palette.vermillion), function (props) {
    return props.visible ? 1 : 0;
}, function (props) {
    return props.visible ? '1, 1, 1' : '0.05, 0.05, 1';
}, function (props) {
    return props.visible ? 0.6 : 0;
}, function (props) {
    return props.visible ? 0.6 : 0;
}, _utils_1.mediaQuery('tablet'), _utils_1.mediaQuery('laptop'), _utils_1.mediaQuery('desktop'));
var Cross = styled_components_1.default.div.withConfig({
    displayName: "Modal__Cross",
    componentId: "sc-64uwmw-4"
})(["position:absolute;z-index:-1;left:calc(50% - 8px);display:flex;justify-content:center;align-items:center;width:16px;height:14px;opacity:0;transition:opacity 0.35s 0.25s ease-in-out;&::before,&::after{position:absolute;background-color:", ";height:2px;width:100%;border-radius:0 1px 1px 0;content:'';transform:rotate3d(0,0,1,0deg);transition:all 0.35s ease-in-out;}", ""], _theme_1.palette.snow, function (props) {
    return props.visible && "\n    opacity: 1;\n    transition-delay: 1.2s;\n    &::before,\n    &::after {transition-delay: 1.2s;}\n    &::before {transform: rotate3d(0, 0, 1, 45deg);}\n    &::after {transform: rotate3d(0, 0, 1, -45deg);}\n  ";
}); // Close Shroud
var CloseShroud = styled_components_1.default.div.withConfig({
    displayName: "Modal__CloseShroud",
    componentId: "sc-64uwmw-5"
})(["position:fixed;z-index:-1;top:0;left:0;width:100%;height:100%;cursor:pointer;"]); // shared external modal helpers
exports.ModalWrapper = styled_components_1.default.div.withConfig({
    displayName: "Modal__ModalWrapper",
    componentId: "sc-64uwmw-6"
})(["display:flex;flex-direction:column;align-items:center;background:", ";width:100%;padding:48px 24px;box-shadow:0px 0.5px 0px rgba(0,0,0,0.08),0px 16px 24px rgba(0,0,0,0.08);margin:0 auto;", "{max-width:688px;padding:56px 40px;}", "{max-width:944px;padding-top:64px;padding-bottom:64px;}", "{max-width:1200px;padding-top:80px;padding-bottom:80px;}"], _theme_1.palette.snow, _utils_1.mediaQuery('tablet'), _utils_1.mediaQuery('laptop'), _utils_1.mediaQuery('desktop'));
exports.ModalContent = styled_components_1.default.div.withConfig({
    displayName: "Modal__ModalContent",
    componentId: "sc-64uwmw-7"
})(["width:100%;max-width:380px;", "{max-width:480px;}", "{max-width:592px;}", "{max-width:680px;}"], _utils_1.mediaQuery('tablet'), _utils_1.mediaQuery('laptop'), _utils_1.mediaQuery('desktop'));
exports.ModalCopy = styled_components_1.default.div.withConfig({
    displayName: "Modal__ModalCopy",
    componentId: "sc-64uwmw-8"
})(["z-index:2;position:relative;width:100%;max-width:428px;margin-bottom:32px;", "{width:420px;max-width:none;margin-bottom:40px;}", "{width:520px;}", "{width:660px;margin-bottom:48px;}"], _utils_1.mediaQuery('tablet'), _utils_1.mediaQuery('laptop'), _utils_1.mediaQuery('desktop'));
exports.ModalHeadline = styled_components_1.default.h2.withConfig({
    displayName: "Modal__ModalHeadline",
    componentId: "sc-64uwmw-9"
})(["", " color:", ";"], _theme_1.type.h2, _theme_1.palette.black);
exports.ModalSubhead = styled_components_1.default.p.withConfig({
    displayName: "Modal__ModalSubhead",
    componentId: "sc-64uwmw-10"
})(["padding-top:7px;", " color:", ";", "{padding-top:8px;}", "{padding-top:14px;}", "{padding-top:20px;}"], _theme_1.type.p, _theme_1.palette.ink, _utils_1.mediaQuery('tablet'), _utils_1.mediaQuery('laptop'), _utils_1.mediaQuery('desktop'));
exports.ModalButtonWrapper = styled_components_1.default.div.withConfig({
    displayName: "Modal__ModalButtonWrapper",
    componentId: "sc-64uwmw-11"
})(["padding-top:8px;& > div{margin-bottom:16px;}& > div:last-of-type{margin-bottom:0;}", "{padding-top:16px;}"], _utils_1.mediaQuery('desktop'));
exports.ModalList = styled_components_1.default.dl.withConfig({
    displayName: "Modal__ModalList",
    componentId: "sc-64uwmw-12"
})(["", " padding-top:24px;& span{position:relative;display:block;padding:4px 0;width:fit-content;overflow:hidden;}& dt{padding-right:16px;}", "{", " padding-top:32px;& span{padding:8px 0;}}"], _theme_1.type.labelLarge, _utils_1.mediaQuery('laptop'), _theme_1.type.label);
exports.ModalRow = styled_components_1.default.div.withConfig({
    displayName: "Modal__ModalRow",
    componentId: "sc-64uwmw-13"
})(["display:flex;justify-content:space-between;"]); // Typing
exports.default = Modal;
